import { graphql } from '~publish/graphql'
import type { ResultOf, VariablesOf } from '~publish/graphql'
import { CollaborationNoteFields } from './fragments/CollaborationNoteFields'
import { CollaborationNoteWithActionsFields } from './fragments/CollaborationNoteWithActionsFields'
import type { NoteSubject } from './noteSubject'

export { CollaborationNoteFields }

export { CollaborationNoteWithActionsFields }

export const NotesQuery = graphql(
  `
    query NotesFeedQuery(
      $input: CollaborationNotesInput!
      $first: Int
      $after: String
    ) {
      collaborationNotes(input: $input, first: $first, after: $after) {
        edges {
          cursor
          node {
            ...CollaborationNoteWithActionsFields
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  `,
  [CollaborationNoteWithActionsFields],
)

export type CreatedNote = ResultOf<typeof CollaborationNoteFields>
export type CollaborationNote = ResultOf<
  typeof CollaborationNoteWithActionsFields
>
export type NotesVariables = VariablesOf<typeof NotesQuery>
export type NoteReaction = CollaborationNote['reactions'][number]
export type NoteReactionAccount = NoteReaction['accounts'][number]

export type NotesInput = NotesVariables['input']

/** The thread input for a subject. */
export const notesInput = (subject: NoteSubject): NotesInput => ({
  subject:
    subject.subjectType === 'post'
      ? { postId: subject.subjectId }
      : { contentItemId: subject.subjectId },
})
